module.exports = __webpack_public_path__ + "img/u_phone-volume.09fe542b.svg";